
<a
  :href="productUrl(product.id)"
  class="product-card-container font-rubik relative flex flex-col justify-end"
>
  <img
    :src="product.primary_photo"
    :alt="product.name"
    class="max-h-[136px] absolute top-1/2 -translate-y-1/2 left-0 mx-[20px]"
  >
  <span
    v-if="product.name"
    :class="[
      { 'text-[1rem]': product.name.length >= 29 && product.name.length < 36 },
      { 'text-[0.8rem]': product.name.length >= 36 }
    ]"
    class="text-center"
  >
    {{ product.name }}
  </span>
</a>
